/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import Layout from "../components/layout/Layout";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button } from "react-bootstrap";

// images
import { useSelector } from "react-redux";
import { blobURL } from "common/StringUtils";
import { LOCALES } from "common/constants";

const HowItWorks = ({ dashboardFooter }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const workBanner = `${blobURL}/howitworksImg.jpg`;
  const videoImg = `${blobURL}/video1.png`;

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const user = useSelector((state) => state.auth.user);
  let language = localStorage.getItem("i18nextLng");

  return (
    <Layout dashboardFooter={dashboardFooter}>
      <Helmet>
        <title>
          {t(
            "This is how it works | Self-employment and invoicing without a company | InvoiceNow"
          )}
        </title>
        <meta
          name="description"
          content={t(
            "With Invozio, you can charge for your services through self-employment - invoice without a company and get paid quickly.."
          )}
        />
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/how-works-invozio"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/hur-fungerar-invozio"
          />
        )}
      </Helmet>

      <section className="banner work-banner howit_works new_bannr_howwork new_margin_header">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="left-content">
                <h1 className="security_about ">{t("THAT IS HOW IT WORKS")}</h1>
                <div className="video-content text-md-left">
                  <h2
                    style={{
                      color: "#634CB7",
                      textTransform: "uppercase",
                      fontWeight: "700",
                    }}
                  >
                    {t("VIDEO INSTRUCTIONS")}
                  </h2>
                </div>
                <p>
                  {t(
                    "Invoicing without a company should be simple and smooth. At Invozio, we have made the process as intuitive and user-friendly as possible. Here's an overview of how invoicing with us works:"
                  )}
                </p>
                <div className="account">
                  {!user && (
                    <Button
                      variant=""
                      className="mt-2 new_theme_btn"
                      onClick={() =>
                        navigate(
                          language === LOCALES.EN_US
                            ? `/emailregister?lang=${LOCALES.EN_US}`
                            : `/e-postregister?lang=${LOCALES.SV_SE}`
                        )
                      }
                    >
                      {t("Create Free Account")}
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="right-content">
                <img src={workBanner} className="wb img-fluid" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="try new_try_sectn">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-3 mb-md-3">
              <div className="card h-100 rounded-lg p-3 text-center">
                <h4 className="font-weight-bold text-uppercase">
                  {t("Create an account")}
                </h4>
                <p className="mb-0">
                  {t(
                    "Start by creating an account with us by filling in your basic information. It only takes a few minutes, and you're ready to go."
                  )}
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-3 mb-md-3">
              <div className="card h-100 rounded-lg p-3 text-center">
                <h4 className="font-weight-bold text-uppercase">
                  {t("Fill in the invoice details")}
                </h4>
                <p className="mb-0">
                  {t(
                    "Once you are logged into your account, you can easily fill in the invoice details. Enter the amount, date and any additional information for your invoice."
                  )}
                </p>
              </div>
            </div>
            <div className="col-md-4 mb-3 mb-md-3">
              <div className="card h-100 rounded-lg p-3 text-center">
                <h4 className="font-weight-bold text-uppercase">
                  {t("Send the invoice")}
                </h4>
                <p className="mb-0">
                  {t(
                    "With just one click, you can send your invoice to your customer. We ensure that the invoice reaches the right person at the right time."
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="video-first-group vdw_nw_design">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="video">
                <img src={videoImg} className="img-fluid" loading="lazy" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="video-content text-md-right text-sm-center">
                <h2>{t("VIDEO ABOUT")}.....</h2>
                <p>{t("Coming soon instruction videos")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="video-second-group scnd_respns">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="video-content text-md-left text-sm-center">
                <h2>{t("VIDEO ABOUT")}.....</h2>
                <p>{t("Coming soon instruction videos")}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="video">
                <img src={videoImg} className="img-fluid" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="video-first-group vdw_nw_design">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="video">
                <img src={videoImg} className="img-fluid" loading="lazy" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="video-content text-md-right text-sm-center">
                <h2>{t("VIDEO ABOUT")}.....</h2>
                <p>{t("Coming soon instruction videos")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="video-second-group scnd_respns">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="video-content text-sm-center">
                <h2>{t("VIDEO ABOUT")}....</h2>
                <p>{t("Coming soon instruction videos")}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="video">
                <img src={videoImg} className="img-fluid" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="my-5 pb-3 about">
        <div className="container container-dynamic">
          <div
            className="trustpilot-widget"
            data-locale={LOCALES.SV_SE}
            data-template-id="5406e65db0d04a09e042d5fc"
            data-businessunit-id="64f712e3dbd20bbfcf3a825f"
            data-style-height="28px"
            data-style-width="100%"
            data-theme="light"
          >
            <a
              href="https://se.trustpilot.com/review/invozio.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default HowItWorks;
